import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "search";

export const searchService = {
    searchCaseTicket
};

function searchCaseTicket(search: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/SearchCaseTicket/?search=${search}`, requestOptions).then(handleResponse);
}